export default __webpack_public_path__ + "static/media/unverified_icon.099760eb.svg";